export default "__VITE_ASSET__BuoPvTDI__"